export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "",
        "6": "",
        "7": "",
        "8": "",
        "9": "",
        "10": "",
        "15": "",
        "20": "",
        "25": "",
        "-": "",
        "Adres": "",
        "Adres dostawy": "",
        "Adres e-mail": "",
        "Adres email użytkownika": "",
        "Adres IP użytkownika": "",
        "Aktualizuj cennik": "",
        "Aktywacja produktów": "",
        "Aktywna": "Active",
        "Aktywuj": "",
        "Alert": "",
        "Anulowana": "",
        "Anulowane": "",
        "Anuluj": "Cancel",
        "Anuluj edycję": "",
        "API Key": "",
        "API Key Location": "",
        "API Key Tracking": "",
        "Automatyczna akceptacja": "",
        "Autor": "Author",
        "Blok służy do pobierania kodów promocyjnych z wybranej promocji.": "",
        "Blok służy do wczytania treści powiadomienia według wybranej statusu i wersji językowej.": "",
        "brak": "",
        "Brak": "",
        "Brak cech w grupie": "",
        "Brak historii statusów": "",
        "Brak kategorii nadrzędnej": "",
        "Brak kategorii w grupie": "",
        "Brak kolekcji w kolekcji": "",
        "Brak komentarza": "",
        "Brak notatek": "",
        "Brak produktów w kolekcji": "",
        "Brak produktów w zestawie": "",
        "Brak reklamacji": "",
        "Brak tłumaczenia": "",
        "Brak w magazynie": "",
        "Brak wybranych etykiet": "",
        "Brak wybranych producentów": "",
        "Brak wybranych produktów": "",
        "Brak wyników": "No results",
        "Brutto": "",
        "Cecha została dodana.": "",
        "Cecha została usunięta.": "",
        "Cecha została zaktualizowana.": "",
        "Cechy": "",
        "Cechy odziedziczone po kategoriach nadrzędnych": "",
        "Cechy w grupie": "",
        "Cena aktualna brutto": "",
        "Cena aktualna netto": "",
        "Cena brutto": "",
        "Cena brutto do": "",
        "Cena brutto od": "",
        "Cena dostawy": "",
        "Cena łączna": "",
        "Cena łączna produktu": "",
        "Cena netto": "",
        "Cena netto do": "",
        "Cena netto od": "",
        "Cena produktów": "",
        "Cena sugerowana brutto": "",
        "Cena sugerowana netto": "",
        "Cena zamówienia": "",
        "Cena została zdezaktywowana.": "",
        "Cennik został dodany.": "",
        "Cennik został zaaktualizowany": "",
        "Cenniki": "",
        "Ceny dostawy": "",
        "Client ID": "Client ID",
        "Client Secret": "Client Secret",
        "CRC": "",
        "Customer ID": "",
        "Czas dostawy": "",
        "Czas na zgłoszenie reklamacji (w dniach)": "",
        "Czas na zgłoszenie zwrotu (w dniach)": "",
        "Dane do faktury": "",
        "Dane zostały zapisane": "",
        "Darmowa dostawa": "",
        "Darmowa przesyłka od kwoty (brutto)": "",
        "Data": "",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data oceny": "",
        "Data od": "Date from",
        "Data płatności": "",
        "Data reklamacji": "",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia publikacji jest wymagana": "",
        "Data rozpoczęcia rekomendacji": "",
        "Data ustawienia": "",
        "Data utworzenia": "Creation date",
        "Data wystawienia opinii": "",
        "Data zakończenia": "End date",
        "Data zakończenia rekomendacji": "",
        "Data zamówienia": "",
        "Data zmiany ceny": "",
        "Dev": "",
        "Dezaktywacja ceny jest nieodwracalna, a zdezaktywowana cena nie będzie brana pod uwagę przy obliczaniu najniższej ceny.": "",
        "Dezaktywacja zmiany ceny": "",
        "Dezaktywuj": "",
        "Dezaktywuj zmianę ceny": "",
        "Dhl": "",
        "Długość kodu": "",
        "Dni tygodnia w których jest wysyłane zamówienie": "",
        "Do wysłania (data)": "",
        "Dodaj": "Add",
        "Dodaj cechę": "",
        "Dodaj cennik": "",
        "Dodaj etykietę": "",
        "Dodaj fakturę": "",
        "Dodaj grupę cech": "",
        "Dodaj katalog": "",
        "Dodaj kategorię": "",
        "Dodaj kody": "",
        "Dodaj kolekcję": "",
        "Dodaj kraj": "",
        "Dodaj notatkę": "",
        "Dodaj nowy katalog aby rozpocząć zarządzanie kategoriami.": "",
        "Dodaj parametr UTM": "",
        "Dodaj powiadomienie": "",
        "Dodaj producenta": "",
        "Dodaj produkt": "",
        "Dodaj promocję": "",
        "Dodaj sklep": "",
        "Dodaj sposób dostawy": "",
        "Dodaj sposób płatności": "",
        "Dodaj stawkę": "",
        "Dodaj walutę": "",
        "Dodaj wartość": "",
        "Dodaj wpis w kalendarzu": "",
        "Dodaj zakres": "",
        "Dodane przez": "Added by",
        "Dodanie cechy": "",
        "Dodanie cennika": "",
        "Dodanie etykiety": "",
        "Dodanie faktury": "",
        "Dodanie grupy cech": "",
        "Dodanie kategorii": "",
        "Dodanie kolekcji": "",
        "Dodanie kraju": "",
        "Dodanie opcji dostawy": "",
        "Dodanie opcji płatności": "",
        "Dodanie parametru UTM": "",
        "Dodanie powiadomienia": "",
        "Dodanie producenta": "",
        "Dodanie produktu": "",
        "Dodanie promocji": "",
        "Dodanie sklepów": "",
        "Dodanie stawki": "",
        "Dodanie waluty": "",
        "Dodanie wartości": "",
        "Dodanie wpisu do kalendarza": "",
        "Dodawanie etykiet": "",
        "Dodawanie kategorii": "",
        "Dodawanie kodów": "",
        "Dodawanie kolekcji": "",
        "Dodawanie producenta": "",
        "Dokonaj dopłaty faktury": "",
        "Domyślna waluta": "",
        "Domyślny limit (brutto)": "",
        "Dopłacenie faktury": "",
        "Dopłać": "",
        "Dostawa": "",
        "Dostawa na palecie": "",
        "Dostawa w godzinach wieczornych": "",
        "Dostawa w sobotę": "",
        "Dostawie nie przypisano żadnych form płatności": "",
        "Dostawy": "",
        "Dostawy i płatności": "",
        "Dostępna liczba kodów dla tego wzoru:": "",
        "Dostępne metody płatności": "",
        "Dotpay": "",
        "Drugi klucz (MD5)": "",
        "Działania masowe": "Bulk actions",
        "EAN-13": "",
        "Edycja": "",
        "Edycja cechy": "",
        "Edycja cennika": "",
        "Edycja etykiety": "",
        "Edycja grupy cech": "",
        "Edycja kategorii": "",
        "Edycja kolekcji": "",
        "Edycja kraju": "",
        "Edycja opcji dostawy": "",
        "Edycja opcji płatności": "",
        "Edycja parametru UTM": "",
        "Edycja powiadomienia": "",
        "Edycja producenta": "",
        "Edycja produktu": "",
        "Edycja promocji": "",
        "Edycja sklepów": "",
        "Edycja stawki": "",
        "Edycja waluty": "",
        "Edycja wpisu do kalendarza": "",
        "Edytuj": "Edit",
        "Edytuj katalog": "",
        "Edytuj notatkę": "",
        "Efekt kodu": "",
        "Eksportuj": "",
        "Eksportuj produkty": "",
        "Elementy zestawu": "",
        "Email użytkownika": "",
        "Etykieta": "",
        "Etykieta priorytetowa": "",
        "Etykieta produktu została dodana.": "",
        "Etykieta produktu została usunięta.": "",
        "Etykieta produktu została zaktualizowana.": "",
        "Etykiety": "",
        "Faktura została dodana.": "",
        "Faktura została zaktualizowana.": "",
        "Faktury": "",
        "Firma": "",
        "Format ceny": "",
        "Format kodu pocztowego": "",
        "Format kodu powinien być wyrażeniem regularnym": "",
        "Formularz": "",
        "Generowanie kodów": "",
        "Generuj nowe kody": "",
        "Generuj warianty": "",
        "Generuj wszystkie metadane": "",
        "Głębokość": "",
        "Godzina rozpoczęcia": "",
        "Godzina wysyłki zamówień": "",
        "Godzina zakończenia": "",
        "grid": "",
        "Grupa cech": "",
        "Grupa cech została dodana.": "",
        "Grupa cech została usunięta.": "",
        "Grupa cech została zaktualizowana.": "",
        "Grupy cech": "",
        "Happy hours": "",
        "Hasło użytkownika": "",
        "Historia faktur": "",
        "Historia statusów": "",
        "Historia zmian cen produktu": "",
        "Historia zmian ceny": "",
        "Id": "Id",
        "ID": "ID",
        "ID organizacji": "",
        "Id punktu płatności (pos_id)": "",
        "ID sklepu": "",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "",
        "Identyfikator sprzedawcy": "",
        "Ikona wartości": "",
        "Ilość": "",
        "Ilość dni, po których koszyk jest usuwany": "",
        "Ilość dni, po których koszyk jest uznany za opuszczony": "",
        "Ilość ocen": "",
        "Ilość polubień": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość produktu jaka ma zostać w magazynie. W pierwszej kolejności brana po uwagę jest wartość z wariantu, następnie z produktu a na końcu z kategorii.": "",
        "Ilość reklamacji": "",
        "Ilość reklamowana": "",
        "Ilość w magazynie": "",
        "Ilość w magazynie do": "",
        "Ilość w magazynie od": "",
        "Ilość zamówień": "",
        "Imię": "First name",
        "Imię klienta": "",
        "Importuj produkty": "",
        "Indywidualny": "",
        "Inne oczekiwania": "",
        "Inpost": "",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, to zostanie użyta nazwa kategorii.": "",
        "Język": "Language",
        "Kalendarz": "",
        "Kampania (utm_campaign)": "",
        "Kampanie": "",
        "Katalog": "",
        "Katalog został usunięty.": "",
        "Katalog został utworzony.": "",
        "Katalogi kategorii": "",
        "Kategoria": "Category",
        "Kategoria główna": "",
        "Kategoria nadrzędna": "",
        "Kategoria widoczna": "",
        "Kategorie": "",
        "Klient": "",
        "Kod": "",
        "Kod ISO": "",
        "Kod pocztowy": "",
        "Kod promocyjny": "",
        "Kod rabatowy": "",
        "Kod został usunięty.": "",
        "Kody promocyjne zostały dodane.": "",
        "Kody promocyjne zostały wygenerowane.": "",
        "Kody rabatowe": "",
        "Kody zostały usunięte.": "",
        "Kolekcja aktywna": "",
        "Kolekcja została dodana.": "",
        "Kolekcja została zaktualizowana.": "",
        "Kolekcje": "",
        "Kolor dekoracji tekstu": "",
        "Kolor obramowania": "",
        "Kolor tekstu": "",
        "Kolor tła": "Background color",
        "Komentarz": "",
        "Komentarz do zamówienia": "",
        "Konfiguracja": "",
        "Konfiguruj kategorię": "",
        "Kopiuj": "Copy",
        "Koszt płatności": "",
        "Koszt płatności brutto": "",
        "Koszyki": "",
        "Kraj": "",
        "Kraj produkcji": "",
        "Kraj został dodany.": "",
        "Kraj został usunięty.": "",
        "Kraj został zaktualizowany.": "",
        "Kraje": "",
        "Kupujący": "",
        "Kurs": "",
        "Kwota brutto": "",
        "Kwota netto": "",
        "Kwotowy": "",
        "Legacy": "",
        "Liczba dni przechowywania": "",
        "Liczba kodów promocyjnych": "",
        "Liczba nowych kodów": "",
        "Liczba użyć": "",
        "Liczba wyników na stronie": "Number of results per page",
        "Liczba wyświetlanych produktów": "",
        "Limit czasowy rezerwacji (w minutach)": "",
        "Limit kupiecki": "",
        "Link do pełnej dokumentacji": "",
        "Lista dostawców obsługujących ten sklep oraz rodzaje płatności dostępne po wybraniu określonego dostawcy podczas składania zamówienia.": "",
        "Logo": "Logo",
        "lub wpisz wartość": "",
        "Maksimum logistyczne": "",
        "Maksymalna liczba produktów": "",
        "Maksymalna liczba użyć": "",
        "Maksymalna wartość rabatu": "",
        "Maksymalna wartość zamówienia przed doliczeniem kosztów dostawy (brutto)": "",
        "Margines dla produktów": "",
        "Marketing": "",
        "Media": "",
        "Medium (utm_medium)": "",
        "Metadane": "",
        "Miasto": "",
        "Miniatura zdjęcia": "",
        "Miniaturka": "",
        "Minimum logistyczne": "",
        "Mnożnik": "",
        "Moduł dostawy": "",
        "Moduł płatności": "",
        "MPN": "",
        "Multimedia": "",
        "n/a": "",
        "Na status": "",
        "Na stronie": "",
        "Nadkreślenie": "",
        "Najniższa cena z 30 dni brutto": "",
        "Najpierw wybierz wariant przeliczenia": "",
        "Najpierw zapisz wprowadzone zmiany": "",
        "Należy pamiętać, że może istnieć tylko jeden ciąg zmiennych.nnMożliwe zmienne do użycia:n- %d - Cyfry (0-9)n- %s - Litery (A-Z)": "",
        "Name": "Name",
        "Nazwa": "Name",
        "Nazwa cechy": "",
        "Nazwa etapu": "",
        "Nazwa firmy": "",
        "Nazwa grupy cech": "",
        "Nazwa kategorii": "",
        "Nazwa klienta": "",
        "Nazwa kolekcji": "",
        "Nazwa parametru": "",
        "Nazwa powiadomienia": "Notification name",
        "Nazwa producenta": "",
        "Nazwa produktu": "",
        "Nazwa promocji": "",
        "Nazwa sklepu": "",
        "Nazwa sposobu dostawy": "",
        "Nazwa sposobu płatności": "",
        "Nazwa użytkownika": "Username",
        "Nazwa wpisu do kalendarza": "",
        "Nazwa wyświetlana": "",
        "Nazwisko": "Last name",
        "Nazwisko klienta": "",
        "Netto": "",
        "Nie": "No",
        "Nie pozwól zamówić": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się załadować widgetu źródło pochodzenia zamówienia.": "",
        "Nie uwzględniaj dla produktów z dostawą na palecie": "",
        "Nie wybrano żadnego produktu.": "",
        "Nie wybrano żadnej opinii.": "",
        "Niektóre wersje językowe zostały już przypisane do innych sklepów.": "",
        "Nielimitowana": "",
        "Niestandardowa wiadomość": "",
        "Niestandardowy wzór": "",
        "NIP": "",
        "Notatka": "",
        "Notatka administracyjna": "",
        "Notatka administracyjna została zapisana.": "",
        "Notatka została dodana.": "",
        "Notatka została usunięta.": "",
        "Notatka została zapisana.": "",
        "Notatki": "",
        "Nowe": "",
        "Nowe zgłoszenie": "",
        "Numer": "",
        "Numer budynku": "",
        "Numer domu / mieszkania": "",
        "Numer faktury": "",
        "Numer kierunkowy": "",
        "Numer konta": "",
        "Numer reklamacji": "",
        "Numer telefonu": "Phone number",
        "Numer zamówienia": "",
        "Numer zgłoszenia": "",
        "Obniżenie ceny": "",
        "Ocena": "",
        "Oceniony produkt": "",
        "Oczekujące": "Pending",
        "Oczekuje na płatność": "",
        "Oczekuje na wysłanie": "Pending to send",
        "Odbiorca": "",
        "Odbiorca (firma)": "",
        "Odbiór osobisty": "",
        "Odrzucone": "Rejected",
        "Odrzucony": "",
        "Odstęp górnej oraz dolnej krawędzi od tekstu": "",
        "Odstęp lewej oraz prawej krawędzi od tekstu": "",
        "Ogólne": "",
        "Operacja spowoduje trwałe usunięcie wszystkich kategorii należących do tego katalogu!nnCzy na pewno chcesz wykonać akcję?": "",
        "Opinia została usunięta.": "",
        "Opinia została zaktualizowana.": "",
        "Opinie": "",
        "Opinie produktowe": "",
        "Opinie zostały zaktualizowane": "",
        "Opis": "Description",
        "Opis wartości": "",
        "Opisy": "Descriptions",
        "Opłacona": "",
        "Opłacone": "",
        "Opublikowany": "",
        "Osoba fizyczna": "",
        "Ostatnio zmodyfikowane": "",
        "Parametr UTM został dodany.": "",
        "Parametr UTM został zaktualizowany.": "",
        "Parametr został usunięty.": "",
        "Parametry logistyczne": "",
        "Parametry UTM": "",
        "PayPal": "",
        "PayU": "",
        "PIN": "",
        "Plik faktury": "",
        "Płatności": "",
        "Płatności przypisane do dostawy": "",
        "Płatność": "",
        "Płatność przy odbiorze": "",
        "płatność wyłączona": "",
        "Płatność za pobraniem": "",
        "Po upływie tego czasu (liczonego od czasu utworzenia rezerwacji) rezerwacja przestanie obowiązywać (0 - brak limitu).": "",
        "Po upływie tego czasu nie bedzie można złożyć reklamacji. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane. ": "",
        "Po upływie tego czasu nie bedzie można złożyć zwrotu. Czas naliczany jest od momentu zmiany statusu zamówienia na Zrealizowane.": "",
        "Po wybraniu efektu kodu, nie można go zmienić.": "",
        "Po wybraniu tej opcji opinie zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po wybraniu tej opcji produkty zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po wybraniu typu kodu, nie można go zmienić.": "",
        "Po wybraniu typu promocji, nie można go zmienić.": "",
        "Po zmianie stawki podatku możesz przeliczyć ceny produktów, zachowując przy tym cenę netto lub brutto. Zachowanie ceny netto przelicza cenę brutto, a zachowanie ceny brutto przelicza cenę netto zgodnie z nową wartością przypisanego podatku.": "",
        "Pobierz etykietę": "",
        "Pobierz etykiety": "",
        "Pobranie": "",
        "Pobranie kodu promocyjnego": "",
        "Pochylenie": "",
        "Podatek": "",
        "Podatki": "",
        "Podatki zostały zaktualizowane": "",
        "Podgląd": "Preview",
        "Podgląd kodu": "",
        "Podkreślenie": "",
        "Podsumowanie": "",
        "Pogrubienie": "",
        "Pokaż kafelki do ostatniego poziomu": "",
        "Pokaż kafelki do wybranego poziomu": "",
        "Pole \"Promocja\" jest wymagane.": "",
        "Pole \"Sklep\" jest wymagane.": "",
        "Pomoc": "",
        "Posiada wagę": "",
        "Posiada zdjęcie": "",
        "Potwierdzenie": "",
        "Potwierdzenie dezaktywacji": "",
        "Potwierdzenie kopiowania": "Copy confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie usunięciannWykonanie tej akcji nie spowoduje usunięcia tej cechy przypisanej do produktów.": "",
        "Powiadomienia": "Notifications",
        "Powiadomienie do zamówienia": "",
        "Powiadomienie zostało dodane.": "",
        "Powiadomienie zostało zaktualizowane.": "",
        "Powód dezaktywacji": "",
        "Powód dezaktywacji ceny": "",
        "Powrót": "Back",
        "Pozostałe parametry": "",
        "Pozostałe zdjęcia": "",
        "Pozwól zamawiać": "",
        "Priorytet": "",
        "Procentowy": "",
        "Producenci": "",
        "Producent": "",
        "Producent aktywny": "",
        "Producent został dodany.": "",
        "Producent został zaktualizowany.": "",
        "Produkt": "",
        "Produkt bazowy": "",
        "Produkt opublikowany": "",
        "Produkt posiada warianty": "",
        "Produkt rekomendowany": "",
        "Produkt został dodany.": "",
        "Produkt został skopiowany.": "",
        "Produkt został usunięty.": "",
        "Produkt został zaktualizowany.": "",
        "Produkty": "",
        "Produkty komplementarne": "",
        "Produkty rekomendowane": "",
        "Produkty uwzględnione w promocji": "",
        "Produkty w promocji": "",
        "Produkty w zestawie": "",
        "Produkty wraz z wariantami": "",
        "Produkty zostały aktywowane": "",
        "Produkty zostały dezaktywowane": "",
        "Produkty zostały usunięte z systemu": "",
        "Produkty zostały zaktualizowane": "",
        "Promocja": "",
        "Promocja włączona": "",
        "Promocja została dodana.": "",
        "Promocja została usunięta.": "",
        "Promocja została zaktualizowana.": "",
        "Promocje": "",
        "Protokół OAuth - client_id": "",
        "Protokół OAuth - client_secret": "",
        "Przecena produktów": "",
        "Przecena zamówienia": "",
        "Przedrostek": "",
        "Przekreślenie": "",
        "Przekroczono dozwoloną liczbę znaków (255)": "",
        "Przelew tradycyjny": "",
        "Przelewy24": "",
        "Przelicz": "",
        "Przelicz podatek": "",
        "Przelicz podatki": "",
        "przez": "",
        "Przykład: ^\\d{5}$": "",
        "Przykład: 00000": "",
        "Przypisany": "",
        "Przyrostek": "",
        "Publikuj do": "",
        "Publikuj od": "",
        "Rabat": "",
        "Reguła podatku": "",
        "Reklamacja": "",
        "Reklamacje": "",
        "Reklamacje i zwroty": "",
        "Rezerwacja stanów magazynowych": "",
        "Ręczna akceptacja": "",
        "Rodzaj płatności": "",
        "Rozmiar paczki": "",
        "Secret ID": "",
        "Sklep": "",
        "Sklep został dodany.": "",
        "Sklep został usunięty.": "",
        "Sklep został zaktualizowany.": "",
        "Sklepy": "",
        "Skopiuj": "",
        "SKU": "",
        "slider": "",
        "Słowa kluczowe": "",
        "Sortowanie cech": "",
        "Sortowanie grup cech": "",
        "Sortowanie wartości": "",
        "Sortuj cechy": "",
        "Sortuj grupy cech": "",
        "Sortuj wartości": "",
        "Sposób dostawy": "",
        "Sposób dostawy włączony": "",
        "Sposób dostawy został dodany.": "",
        "Sposób dostawy został usunięty.": "",
        "Sposób dostawy został zaktualizowany.": "",
        "Sposób płatności włączony": "",
        "Sposób płatności został dodany.": "",
        "Sposób płatności został usunięty.": "",
        "Sposób płatności został zaktualizowany.": "",
        "Sposób wyświetlania kafelków kategorii w katalogu produktów": "",
        "Sprzedaż": "",
        "Stały": "",
        "Stan magazynowy": "",
        "Stan magazynu": "",
        "Standardowy": "",
        "Status": "Status",
        "Status dostawy": "",
        "Status faktury": "",
        "Status kupującego": "",
        "Status opinii": "",
        "Status płatności": "",
        "Status reklamacji został zmieniony.": "",
        "Status zamówienia": "",
        "Stawka domyślna": "",
        "Stawka podatku": "",
        "Stawka została dodana.": "",
        "Stawka została usunięta.": "",
        "Stawka została zaktualizowana.": "",
        "Stawki podatku w poszczególnych państwach": "",
        "Strefa czasowa": "",
        "Strona została dodana.": "",
        "Strona została usunięta.": "",
        "Strona została zaktualizowana.": "",
        "Styl dekoracji tekstu": "",
        "Styl obramowania": "",
        "Sugerowana cena": "",
        "Suma cen produktów od której naliczany jest rabat (brutto)": "",
        "Symbol": "",
        "Symbol kategorii": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Synchronizuj": "",
        "System opinii włączony": "",
        "Szablon": "",
        "Szczegóły faktury": "",
        "Szczegóły kolekcji": "",
        "Szczegóły opinii": "",
        "Szczegóły wartości": "",
        "Szczegóły zamówienia": "",
        "Szczegóły zgłoszenia": "",
        "Szerokość": "Width",
        "szt": "",
        "Środowisko": "",
        "Ta forma dostawy jest wyłączona": "",
        "Ta forma płatności jest wyłączona": "",
        "Tak": "Yes",
        "Tekst wyświetlany podczas ustawienia blokady": "",
        "Telefon": "",
        "Temat": "",
        "Token API ShipX": "",
        "Token Geowidget": "",
        "tPay": "",
        "Treść notatki": "",
        "Treść opinii": "",
        "Tworzenie cennika": "",
        "Tworzenie faktury": "",
        "Tworzenie wariantów": "",
        "Typ": "Type",
        "Typ dostawy": "",
        "Typ kodu": "",
        "Typ notatki": "",
        "Typ rabatu": "",
        "Ukryj kafelki": "",
        "Ulica": "",
        "URL płatności": "",
        "Ustawienia darmowej dostawy": "",
        "Ustawienia domyślne": "",
        "Ustawienia historii przeglądanych produktów": "",
        "Ustawienia katalogu produktów": "",
        "Ustawienia kategorii": "",
        "Ustawienia kodu pocztowego": "",
        "Ustawienia podstawowe": "",
        "Ustawienia rabatu": "",
        "Ustawienia sklepu": "",
        "Ustawienia webservice": "",
        "Ustawienia wyświetlania": "",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usunięcie wady": "",
        "Usuń": "Delete",
        "Usuń cechę": "",
        "Usuń katalog": "",
        "Usuń kategorię": "",
        "Usuń producenta": "",
        "Usuń produkt": "",
        "Usuwanie opinii": "",
        "Usuwanie produktów": "",
        "Utworzona": "",
        "Utworzył": "Created",
        "Utwórz": "",
        "Użyj niestandardowego wzoru": "",
        "Użytkownik": "User",
        "Użyty": "",
        "W magazynie": "",
        "W temacie i treści wiadomości można korzystać z systemu szablonów języka Liquid do parsowania danych pochodzących z zamówienia.": "",
        "W trakcie realizacji": "",
        "W trakcie rozpatrywania": "",
        "W tym katalogu nie ma jeszcze żadnych kategorii.": "",
        "Waga": "",
        "Waluta": "",
        "Waluta została dodana.": "",
        "Waluta została usunięta.": "",
        "Waluta została zaktualizowana.": "",
        "Waluty": "",
        "Wariant produktu": "",
        "Warianty": "",
        "Warianty prodktu zostały utworzone.": "",
        "Wartości": "",
        "Wartości cechy": "",
        "Wartości liczbowa": "",
        "Wartości numeryczne": "",
        "Wartości tekstowa": "",
        "Wartość": "",
        "Wartość numeryczna": "",
        "Wartość rabatu (brutto)": "",
        "Wartość tekstowa": "",
        "Wartość wymagana": "",
        "Wartość została dodana.": "",
        "Wartość została zaktualizowana.": "",
        "Wersja API": "",
        "Wiadomość": "",
        "Wielkość obramowania": "",
        "Wielkość tekstu": "",
        "Witryny": "",
        "Właściwości": "Properties",
        "Włącz dodatkowe pola dla reklamacji": "",
        "Wpis aktywny": "",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wpis do kalendarza został zaktualizowany.": "",
        "Wpis w kalendarzu został dodany.": "",
        "Wpis w kalendarzu został zaktualizowany.": "",
        "Wpisz wartości po przecinku.": "",
        "Wpływ na wariantowość produktu": "",
        "Wprowadź kod rabatowy...": "",
        "Wprowadź nazwę promocji...": "",
        "Wprowadź treść": "",
        "Wstąpił błąd przy dodawaniu notatki.": "",
        "Wstąpił błąd przy usuwaniu notatki.": "",
        "Wszystkie": "All",
        "Wszystkie wersje językowe zostały już przypisane do innych sklepów.": "",
        "Wszystko": "Everything",
        "wybierz": "select",
        "Wybierz cechę": "",
        "Wybierz datę": "",
        "Wybierz etykietę, którą chcesz przypisać do produktów": "",
        "Wybierz etykiety produktów": "",
        "Wybierz formularz zawierający dodatkowe pola dla reklamacji": "",
        "Wybierz kategorię": "",
        "Wybierz kategorię, którą chcesz przypisać do produktów": "",
        "Wybierz kolekcję": "",
        "Wybierz kolekcję, którą chcesz przypisać do produktów": "",
        "Wybierz opcję": "Select option",
        "Wybierz opinie dla których chcesz wykonać akcje": "",
        "Wybierz poziom": "",
        "Wybierz producenta, którego chcesz przypisać do produktów": "",
        "Wybierz producentów": "",
        "Wybierz produkt": "",
        "Wybierz produkt komplementarny": "",
        "Wybierz produkt rekomendowane": "",
        "Wybierz produkty": "",
        "Wybierz produkty dla których chcesz wykonać akcje": "",
        "Wybierz status": "",
        "Wybierz status który chcesz przypisać do opinii": "",
        "Wybierz zakres godzinowy": "",
        "wybierz...": "select...",
        "Wybrana dostawa": "",
        "Wybrana płatność": "",
        "Wybranie etykiety produktu jest wymagane": "",
        "Wybranie formatu jest wymagane": "",
        "Wybranie kategorii jest wymagane": "",
        "Wybranie limitu jest wymagane": "",
        "Wybranie producenta jest wymagane": "",
        "Wybranie produktu jest wymagane": "",
        "Wybrano jeden produkt.": "",
        "Wybrano jedną opinię.": "",
        "Wybranych opinii: %0": "",
        "Wybranych produktów: %0": "",
        "Wygenerowanie nowych kodów spowoduje usunięcie wszystkich istniejących kodów dla tej promocji. Usunięte kody są nieważne i nie można ich już użyć.": "",
        "Wymagany kod pocztowy": "",
        "Wysłane": "Sent",
        "Wysokość": "Height",
        "Wystawiona ocena": "",
        "Wystąpił błąd podczas ładowania danych. Odśwież stronę i spróbuj ponownie": "",
        "Wystąpił błąd podczas próby exportu kodów promocyjnych.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Server error occurred during selected operation. Try again.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Errors in form. Check all form fields.",
        "Wysyłka na palecie": "",
        "wyszukaj etykietę...": "",
        "Wyszukaj etykietę...": "",
        "wyszukaj kategorię...": "",
        "wyszukaj kolekcję...": "",
        "wyszukaj producenta...": "",
        "Wyszukaj producenta...": "",
        "Wyszukaj produkt...": "",
        "Wyszukaj rodzaj płatności...": "",
        "Wyszukaj sklep...": "",
        "Wyszukaj sposób dostawy...": "",
        "Wyszukaj użytkownika...": "",
        "Wyszukaj walutę...": "",
        "Wzór kodu pocztowego": "",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji": "",
        "Zaakceptowane": "",
        "Zaakceptowany": "Accepted",
        "Zachowaj cenę brutto": "",
        "Zachowaj cenę netto": "",
        "Zachowanie przy braku towaru na stanie": "",
        "zacznij pisać aby wyszukać cechę...": "",
        "zacznij pisać aby wyszukać etykietę...": "",
        "zacznij pisać aby wyszukać grupę...": "",
        "zacznij pisać aby wyszukać kolekcję...": "",
        "zacznij pisać aby wyszukać kraj...": "",
        "zacznij pisać aby wyszukać podatek...": "",
        "zacznij pisać aby wyszukać producenta...": "",
        "zacznij pisać aby wyszukać produkt...": "",
        "zacznij pisać aby wyszukać promocję...": "",
        "zacznij pisać aby wyszukać sklep...": "",
        "zacznij pisać aby wyszukać walutę...": "",
        "Załączniki": "",
        "Zamawianie bez rejestracji, przez niezalogowanych klientów": "",
        "Zamiany zostały zapisane.": "",
        "Zamknij": "Close",
        "Zamówienia": "",
        "Zamówienie": "",
        "Zamówienie złożone": "",
        "Zamówienie zostało zaktualizowane.": "",
        "Zapisuj logi": "",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz notatkę": "",
        "Zapisz zmiany": "Save changes",
        "Zapłacono brutto": "",
        "Zarządzaj opiniami": "",
        "Zawiera produkt": "",
        "Zaznacz jako kategorię domyślną": "",
        "Zaznaczone": "",
        "Zdezaktywowany": "",
        "Zdjęcia": "",
        "Zdjęcie": "",
        "Zdjęcie główne": "",
        "Zdjęcie produktu": "",
        "Ze statusu": "",
        "Zestaw": "",
        "Zgłoszenie": "",
        "Zmiana statusu": "",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmienił": "",
        "Zmień status": "",
        "Zmodyfikowane przez": "",
        "Zrealizowane": "",
        "Zwrot": "",
        "Zwroty i reklamacje": "",
        "Źródło": "Source",
        "Źródło (utm_source)": "",
        "Źródło pochodzenia statusu": "",
        "Żródła": ""
    }
};
